import { ChangeDetectorRef, Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  AssetService,
  DocumentsModalV2Component,
  ModalService,
  ReactiveComponent,
  TileV2Module,
  IconV2Module,
  ButtonV2Module,
  FileUploadV2Module,
} from '@schenck/rotec-components';
import { switchMap } from 'rxjs/operators';
import { routes } from 'src/routes';
import { MachineDetailsModalComponent } from '../../machine-details-modal/machine-details-modal.component';
import { MachineInfoWithKpi } from 'src/services';
import { TranslateDirective } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'ma-machine-tile',
  templateUrl: './machine-tile.component.html',
  styleUrls: ['./machine-tile.component.less', '../tile-styles.less'],
  imports: [
    TileV2Module,
    TranslateDirective,
    IconV2Module,
    ButtonV2Module,
    AsyncPipe,
    FileUploadV2Module,
  ],
})
export class MachineTileComponent extends ReactiveComponent {
  private readonly assetService = inject(AssetService);
  private readonly router = inject(Router);
  private readonly modalService = inject(ModalService);
  private readonly cdr = inject(ChangeDetectorRef);

  @Input()
  machine: MachineInfoWithKpi;

  private machine$ = this.onChangesOf$<MachineInfoWithKpi>('machine');
  state = this.connect(
    {
      plant: this.machine$.pipe(switchMap((machine) => this.assetService.plant$(machine.plantId))),
    },
    this.cdr
  );

  constructor() {
    super();
  }

  openDetails() {
    this.modalService.open(MachineDetailsModalComponent, this.machine);
  }

  showTasks() {
    this.router.navigate([routes.machineTasks.absoluteUrl], {
      queryParams: { [routes.machineTasks.params.serial]: this.machine.serial },
    });
  }

  showDocuments() {
    this.modalService.open(DocumentsModalV2Component, this.machine.documentIds);
  }
}
